import React from 'react';
import { Formik, Field as Fieldmik } from 'formik';
import { connect } from 'react-redux'
import * as yup from 'yup';
import { Form as FormUi, Container, Button, Label, Modal } from 'semantic-ui-react'
import { MyInput } from '../../apiInputComponent/myInput';
import { createCategory } from '../../../redux/actions/categoryActions'

function AddCategory(props){

    const validationSchema = yup.object({
        categoryName: yup.string().required(' Required')
    })

    const { handleClose, createCategory } = props

    return (
        <> <Formik
            initialValues={{ categoryName: '' }}
            validationSchema={validationSchema}
            onSubmit = {(values) => {
                console.log("Submit", values)
                createCategory(values)
            }}
            >
                {({ values, isSubmitting, handleSubmit, errors, touched }) => {
                    return (
                        <>
                            <Modal.Content>
                                <Container>
                                    <div className="ui form">
                                        <FormUi.Field>
                                            <label className="labelName p-bold-600">Category* </label>
                                            <Fieldmik name='categoryName' component={MyInput} error={values.categoryName ? false : true } placeholder="Name" />
                                            {touched.categoryName && errors.categoryName ? <Label size="mini" prompt pointing>{errors.categoryName}</Label> : ''}
                                        </FormUi.Field>
                                    </div>
                                </Container>
                            </Modal.Content>
                            <Modal.Actions>
                                {isSubmitting ? 'Loading...' : ''}
                                <Button onClick={handleClose} type="submit" size="tiny">Cancel</Button>
                                <Button type="submit" onClick={handleSubmit} size="tiny" primary>Submit</Button>
                            </Modal.Actions>
                        </>
                    )
                }}
                
                
            </Formik>
        </>
    )
}


export default connect(null, { createCategory })(AddCategory)